import apiFetch from "../../../shared/services/apiClient";

export async function createFilial(data) {
  const res = await apiFetch("/api/residents/filial/", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(JSON.stringify(err));
  }
  return res.json();
}
